export default {
    //葡萄牙语
    DiagnosticReport:'Relatório diagnóstico',
    troubleCode:'Código da falha',
    time:'tempo',
    // 语言
    lang:{
        cn:'Chinês',
        de:'Alemão',
        en:'Inglês',
        es:'Espanhol',
        fr:'Francês',
        it:'Italiano',
        ja:'Japonês',
        ko:'Coreano',
        pt:'Português'
    }
}